module.exports = __webpack_public_path__ + "img/refresh-cw-04.7b6079b2.svg";